export default __webpack_public_path__ + "static/media/q19_05.d8b2ba39.png";